import { Col, Form, Input, Row, Select } from "antd";
import React from "react";
import { indicatorJoin, TimeFormatList } from "../constant";
import { Projection } from "../model";

type Props = {
  timeDimensions: Projection[];
};

const TimeDimension: React.FC<Props> = ({ timeDimensions }) => {
  return (
    <>
      <Row justify="center" align="middle">
        <Col offset={1} span={7}>
          时间维度
        </Col>
        <Col offset={1} span={7}>
          时间格式
        </Col>
        <Col offset={1} span={7}>
          偏移量
        </Col>
      </Row>
      <Row>
        <Col offset={1} span={7}>
          <Form.Item
            name="timeDimension"
            rules={[{ required: true, message: "请选择时间维度" }]}
          >
            <Select style={{ width: "100%" }}>
              {timeDimensions.map((dimention) => (
                <Select.Option
                  key={dimention.id}
                  value={[dimention.name, dimention.expr, dimention.kind].join(
                    indicatorJoin
                  )}
                  style={{ width: "100%" }}
                >
                  {dimention.desc}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col offset={1} span={7}>
          <Form.Item
            name="timeFormat"
            rules={[{ required: true, message: "请选择时间格式" }]}
          >
            <Select style={{ width: "100%" }} dropdownMatchSelectWidth={true}>
              {TimeFormatList.map((item) => (
                <Select.Option
                  value={item.value}
                  key={item.value}
                  style={{ width: "100%" }}
                >
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col offset={1} span={7}>
          <Form.Item
            name="timeOffset"
            rules={[{ required: true, message: "请输入时间偏移量" }]}
          >
            <Input type="number" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default TimeDimension;
